import { render, staticRenderFns } from "./SowosPocketCard.vue?vue&type=template&id=de5a16d2&scoped=true&"
import script from "./SowosPocketCard.vue?vue&type=script&lang=ts&"
export * from "./SowosPocketCard.vue?vue&type=script&lang=ts&"
import style0 from "./SowosPocketCard.vue?vue&type=style&index=0&id=de5a16d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5a16d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VIcon,VRow})
